<template>
  <section style="height: 100%;">
    <div class="ui-paper">
      <div class="sketch" :class="{'animate': isAnimate }"></div>
      <div class="tool tool--pencil" :class="{'animate': isAnimate }"></div>
    </div>
  </section>
</template>

<script>
  export default {
    name: "scene1animation",
    data: function() {
      return {
        isAnimate: false
      };
    },
    methods: {
      animate() {
        this.isAnimate = !this.isAnimate;
      }
    }
  };
</script>

<style lang="scss" scoped>
@import "style";

.sketch {
  background-image: none;
  background-repeat: no-repeat;
  background-size: 100%;
  position: absolute;
  // top:fluid(62px);
  // left:fluid(113px);
  height: fluid(230px);
  width: fluid(331px);

  &.animate {
    animation-name: sketch-paper;
    animation-duration: 3s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
  }
}

.ui-paper {
  background-image: none;
  background-repeat: no-repeat;
  background-size: 100%;
  position: absolute;
  top:fluid(22px);
  left:fluid(50px);
  height: fluid(230px);
  width: fluid(331px);

  &:after {
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden; 
    z-index: -1;
    content: 
      url("~@/assets/img/scene1--sketch0.svg")
      url("~@/assets/img/scene1--sketch1.svg")
      url("~@/assets/img/scene1--sketch2.svg")
      url("~@/assets/img/scene1--sketch3.svg")
      url("~@/assets/img/scene1--sketch4.svg")
      url("~@/assets/img/scene1--sketch5.svg")
      url("~@/assets/img/scene1--sketch6.svg")
      url("~@/assets/img/scene1--sketch7.svg")
      url("~@/assets/img/scene1--sketch8.svg")
      url("~@/assets/img/scene1--sketch9.svg");
  }
}

.tool--pencil {
  position: absolute;
  opacity: 0;
  cursor: auto;

  &.animate {
    opacity: 1;
    animation-name: sketch-pencil;
    animation-duration: 3s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
  }
}

@keyframes sketch-paper {
  0% {
    background-image: url("~@/assets/img/scene1--sketch0.svg");
  }
  10% {
    background-image: url("~@/assets/img/scene1--sketch0.svg");
  }
  20% {
    background-image: url("~@/assets/img/scene1--sketch1.svg");
  }
  30% {
    background-image: url("~@/assets/img/scene1--sketch2.svg");
  }
  40% {
    background-image: url("~@/assets/img/scene1--sketch3.svg");
  }
  60% {
    background-image: url("~@/assets/img/scene1--sketch4.svg");
  }
  80% {
    background-image: url("~@/assets/img/scene1--sketch5.svg");
  }
  85% {
    background-image: url("~@/assets/img/scene1--sketch6.svg");
  }
  90% {
    background-image: url("~@/assets/img/scene1--sketch7.svg");
  }
  95% {
    background-image: url("~@/assets/img/scene1--sketch8.svg");
  }
  100% {
    background-image: url("~@/assets/img/scene1--sketch9.svg");
  }
}

@keyframes sketch-pencil {
  0% {
    top: 70%;
    left: 15%;
  }

  15% {
    top: 40%;
    left: 15%;
  }

  20% {
    top: 30%;
    left: 40%;
  }

  25% {
    top: 30%;
    left: 95%;
  }

  30% {
    top: 89%;
    left: 75%;
  }

  40% {
    top: 37%;
    left: 15%;
  }

  60% {
    top: 37%;
    left: 80%;
  }

  80% {
    top: 80%;
    left: 25%;
  }

  90% {
    top: 70%;
    left: 70%;
  }

  95% {
    top: 70%;
    left: 10%;
  }

  100% {
    top: 93%;
    left: 87%;
  }
}
</style>